import { DataGlueGraph } from '@glueapp/graph-types';
import { ValidationRule, ValidationRuleResult } from './ValidationRule';

/**
 * Simple utility function that runs a list of validation rules against a graph
 * and aggregates the results.
 */
export function validateRules(graph: DataGlueGraph, rules: ValidationRule[]): ValidationRuleResult {
    const allErrors = [];
    let isValid = true;

    for (const rule of rules) {
        const result = rule(graph);
        if (!result.valid) {
            isValid = false;
            allErrors.push(...result.errors);
        }
    }

    return {
        valid: isValid,
        errors: allErrors,
    };
}
